import React,{useState} from "react";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";

import "../Sidebar/Sidebar.css";
import "../AntDMenuNavbar/AntDMenunavbar.css";
import {
  Sidebar,
  Menu,
  MenuItem,
  useProSidebar,
  SubMenu,
  sidebarClasses,
  menuClasses,
} from "react-pro-sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import logo from "../../Assets/Images/emr.png";
import { menuStyles, subMenuStyles } from "../Sidebar/Themes";
import LogoutModal from "../Commons/LogoutModal";
import hamburger from "../../Assets/Images/menus.png";
import { ContactSupportOutlined } from "@mui/icons-material";

function SmallMenu() {
  const navigateto = useNavigate();

  return (
    <>
    <div className={""}>
      <Menu className="mt-2">
        <SubMenu
          icon={
            <FontAwesomeIcon
              icon= {icon({ name: "hamburger" })}
            />
          }
        >
          <MenuItem>
            Download PNG Image
          </MenuItem>
          <MenuItem>
            Download JPEG Image
          </MenuItem>
          <MenuItem>
            Download PDF Document
          </MenuItem>
        </SubMenu>
      </Menu>
    </div>
    </>
  );
}

export default SmallMenu;
